export const initialFeedbackState = {
    isOpen: false
};
export function feedbackReducer(state, action) {
    switch (action.type) {
        case 'feedbackOpen':
            return Object.assign(Object.assign({}, state), { context: {
                    activity: action.activity,
                    sendAnswerFeedback: action.sendAnswerFeedback
                }, isOpen: true });
        case 'feedbackClose':
            return Object.assign(Object.assign({}, state), { isOpen: false });
    }
}
//# sourceMappingURL=FeedbackState.js.map